// extracted by mini-css-extract-plugin
export default {"icon":"FavoriteIcon-module__icon--xoIny","active":"FavoriteIcon-module__active--rv_JM"};